<template>

  <div class="controller-list">

    <h2>{{ $t('title.controllers') }}</h2>

    <el-button
      type="primary"
      size="large"
      @click="emergency">{{ $t('button.emergency') }}</el-button>

    <data-table
      model="controllers"
      :columns="['name', 'ip', 'rssi', 'status']"
      :operations="operations"
      disable-loading-indicator
    />

    <el-dialog :title="$t('title.activate-controller')" :visible="showActivateDialog">

      <p>
        {{ $t('question.controllerCertificate') }}
      </p>

      <p>
        <b>{{ controllerToActivate.readeableHash }}</b>
      </p>

      <el-button type="primary" :loading="loading" @click="activateController">{{ $t('button.accept') }}</el-button>
      <el-button @click="cancelActivation">{{ $t('button.cancel') }}</el-button>

    </el-dialog>


    <el-dialog
      :title="$t('title.remove')"
      :visible="!!modelToDelete"
      width="30%"
      :before-close="() => { modelToDelete = null }">
      <span>{{ $t('remove.message') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modelToDelete = null">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="_deleteOperation">{{ $t('button.confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>
import { CONTROLLER_EDIT } from 'router/routes'
import { post } from 'providers/http'

export default {
  name: 'controller-list',
  data () {
    return {
      showActivateDialog: false,
      controllerToActivate: {},
      loading: false,
      modelToDelete: null
    }
  },
  computed: {
    operations () {
      return [
        {
          label: 'edit',
          icon: 'edit',
          method: this._editOperation,
          permission: ['EDIT_CONTROLLER', 'server_id'],
          precondition: controller => controller.connected
        },
        {
          label: 'activate',
          method: this._activateOperation,
          permission: ['ACTIVATE_CONTROLLER', 'server_id'],
          precondition: controller => !controller.connected,
          disabled: controller => !controller.activable
        },
        {
          label: 'delete',
          type: 'danger',
          icon: 'delete',
          method: (model) => (this.modelToDelete = model),
          permission: ['DELETE_CONTROLLER', 'server_id']
        },
        {
          label: 'sync',
          method: this.synchronizeOperation,
          permission: ['SYNCHRONIZE_CONTROLLER', 'server_id']
        }
      ]
    }
  },
  methods: {
    _editOperation ({ id }) {
      this.$router.push({ name: CONTROLLER_EDIT, params: { id } })
    },
    _activateOperation (controller) {
      this.showActivateDialog = true
      this.controllerToActivate = controller
    },
    _deleteOperation () {
      this.$store.dispatch('controllers/delete', this.modelToDelete)
      this.modelToDelete = null
    },
    async synchronizeOperation (controller) {
      try {
        await post(`api/v1/controllers/synchronizeData/${controller.id}`)
      }
      catch (err) {
        console.error(err)
      }
    },
    cancelActivation () {
      this.showActivateDialog = false
    },
    async activateController () {
      const { id } = this.controllerToActivate
      this.loading = true

      try {
        await post('api/v1/controllers/activate', { id })

        this.controllerToActivate.connected = true
      }
      catch (err) {
        console.error(err)
      }
      finally {
        this.loading = false
        this.showActivateDialog = false
      }
    },
    async emergency () {
      this.loading = true

      await post('api/v1/emergency', { 'state': 2 })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ControllerList.vue?b856e732